import type { DataTableSorting } from './types';

/** Click cycles asc⇄desc on the same column; a new column starts at desc. */
export const toggleSort = <TColumnId extends string>(
  current: DataTableSorting<TColumnId> | undefined,
  columnId: TColumnId
): DataTableSorting<TColumnId> => {
  if (current?.id === columnId) {
    return {
      id: columnId,
      direction: current.direction === 'desc' ? 'asc' : 'desc',
    };
  }
  return { id: columnId, direction: 'desc' };
};
